(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-ufs"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Header Menu Transform-based Sliding (NO OVERFLOW)
  document.addEventListener('DOMContentLoaded', function () {
    const menuContainer = document.querySelector('.header-menu-container');
    const viewport = document.querySelector('.header-menu-viewport');
    const menu = document.querySelector('#header-menu-list');
    const leftBtn = document.querySelector('.header-menu-scroll-btn--left');
    const rightBtn = document.querySelector('.header-menu-scroll-btn--right');

    if (!menuContainer || !viewport || !menu || !leftBtn || !rightBtn) return;

    let currentTranslateX = 0;
    const scrollAmount = 200; // pixels to scroll

    function updateMenuPosition() {
      menu.style.transform = `translateX(${currentTranslateX}px)`;
    }

    function updateScrollButtons() {
      const viewportWidth = viewport.offsetWidth;
      const menuWidth = menu.scrollWidth;
      const maxTranslate = -(menuWidth - viewportWidth);

      // Show/hide left button
      if (currentTranslateX < 0) {
        leftBtn.classList.add('visible');
      } else {
        leftBtn.classList.remove('visible');
      }

      // Show/hide right button
      if (currentTranslateX > maxTranslate && menuWidth > viewportWidth) {
        rightBtn.classList.add('visible');
      } else {
        rightBtn.classList.remove('visible');
      }
    }

    function checkIfScrollNeeded() {
      const viewportWidth = viewport.offsetWidth;
      const menuWidth = menu.scrollWidth;

      if (menuWidth > viewportWidth) {
        updateScrollButtons();
      } else {
        leftBtn.classList.remove('visible');
        rightBtn.classList.remove('visible');
        currentTranslateX = 0;
        updateMenuPosition();
      }
    }

    // Event listeners
    leftBtn.addEventListener('click', () => {
      currentTranslateX += scrollAmount;
      if (currentTranslateX > 0) currentTranslateX = 0;
      updateMenuPosition();
      updateScrollButtons();
    });

    rightBtn.addEventListener('click', () => {
      const viewportWidth = viewport.offsetWidth;
      const menuWidth = menu.scrollWidth;
      const maxTranslate = -(menuWidth - viewportWidth);

      currentTranslateX -= scrollAmount;
      if (currentTranslateX < maxTranslate) currentTranslateX = maxTranslate;
      updateMenuPosition();
      updateScrollButtons();
    });

    // Initial check and on resize
    checkIfScrollNeeded();
    window.addEventListener('resize', () => {
      currentTranslateX = 0; // Reset position on resize
      updateMenuPosition();
      checkIfScrollNeeded();
    });

    // Direkter Click-Handler auf Caret-Buttons (robuster als reine Delegation)
    const caretButtons = menu.querySelectorAll('.header-menu__caret-btn');
    caretButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const li = btn.closest('.header-menu__item-wrapper');
        if (!li) return;
        const isOpen = li.classList.toggle('dropdown-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (!isOpen) {
          li.classList.add('no-hover-open');
        } else {
          li.classList.remove('no-hover-open');
        }
      });
    });

    // Unabhängiges Klicken: Caret-Button oder Caret-Span toggelt Dropdown
    menu.addEventListener('click', function (e) {
      // Fallback-Delegation (falls aus irgendeinem Grund der Button-Handler nicht greift)
      const trigger = e.target.closest('.header-menu__caret-btn, .header-menu__caret');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      const li = trigger.closest('.header-menu__item-wrapper');
      if (!li) return;
      const isOpen = li.classList.toggle('dropdown-open');
      // Hover-Öffnen bei manuellem Schließen verhindern, sonst entfernen
      if (!isOpen) {
        li.classList.add('no-hover-open');
      } else {
        li.classList.remove('no-hover-open');
      }
      // aria-expanded nur setzen, wenn ein Button vorhanden ist
      const btn = li.querySelector('.header-menu__caret-btn');
      if (btn) btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    // Beim Verlassen des Items die Sperre wieder entfernen
    menu.addEventListener('mouseleave', function (e) {
      const items = menu.querySelectorAll('.header-menu__item-wrapper.no-hover-open');
      items.forEach((el) => el.classList.remove('no-hover-open'));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
